import { CanDeactivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ReservationDetailTableComponent } from './reservation-detail-table.component';
import { ReservationCompareStore } from '../../service/reservation-compare-store';

@Injectable()
export class CanDeactiveReservationDetailTable implements CanDeactivate<ReservationDetailTableComponent> {

  constructor(private reservationCompareStore: ReservationCompareStore) {
  }

  canDeactivate(component: ReservationDetailTableComponent,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot): boolean {
    this.reservationCompareStore.setShowReservationSummary(true);
    return true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-can-deactive.ts